import echarts from './echarts.ts';

/** Lazy-load Natural Earth world GeoJSON once (served from `/maps/world.json`). */
let worldMapLoadPromise: Promise<void> | null = null;

export function ensureWorldMapRegistered(): Promise<void> {
  if (worldMapLoadPromise) return worldMapLoadPromise;
  worldMapLoadPromise = fetch('/maps/world.json', {
    credentials: 'same-origin',
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`world map: ${String(res.status)}`);
      }
      return res.json() as Promise<Record<string, unknown>>;
    })
    .then((geojson) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      echarts.registerMap('world', geojson as never);
    })
    .catch((err: unknown) => {
      worldMapLoadPromise = null;
      throw err;
    });
  return worldMapLoadPromise;
}
